import { ApplicationConfig } from '@angular/core';
import { WEB_APP_PROVIDERS } from '@app/bootstrap-apps/web-app/web-app-provider';

export const WEB_APP_BROWSER_CONFIG: ApplicationConfig = {
  providers: WEB_APP_PROVIDERS,
};
